import type { ReactNode } from 'react';
import { Menu } from '@terra/ui-design-system';
import { Portal } from '@ark-ui/react';

type MenuPanelProps = {
  children: ReactNode;
  minW?: string;
  maxW?: string;
};

export function MenuPanel({
  children,
  minW = '280px',
  maxW = '320px',
}: MenuPanelProps) {
  return (
    <Portal>
      <Menu.Positioner zIndex="popover">
        <Menu.Content
          minW={minW}
          maxW={maxW}
          p="2"
          gap="1"
          borderRadius="xl"
          borderWidth="1px"
          borderColor="border.neutral.subtle"
          boxShadow="md"
          bg="bg.neutral.default"
          zIndex="popover"
        >
          {children}
        </Menu.Content>
      </Menu.Positioner>
    </Portal>
  );
}
